var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.loading && _vm.isAnnouncementV1Used)?_c('portal-notification-skelton-loader'):_c('portal-notification-panel',{attrs:{"notification-html":_vm.notificationHtml,"event-html":_vm.eventHtml}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }